import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { useGetBankNameList } from "../../../../../hooks/api/queries";
import primaryComponents from "../../../../primaryComponents";
import { useResolveBankAccount } from "../../../../../hooks/api/mutations/useAccounting";
import { useContext, useEffect } from "react";
import { ToastContext } from "../../../../../hooks/context";
import { WaybillImage } from "../../../../../assets/svgImages";
import { EyeIcon, WaybillIcon } from "../../../../../assets/svgIcons";
import { useUploadImageMutation } from "../../../../../hooks/api/mutations/useMedia";

export const OtherDetails = ({
  itemInfo,
  bulkForm,
  setBulkForm = () => {},
  closeModal = () => {},
}) => {
  const triggerToast = useContext(ToastContext);
  const { data: bankList } = useGetBankNameList({});

  const handleUpdateKey = ({ key = "", value = "" }) => {
    const updatedItems = [...bulkForm?.expenses];
    updatedItems[itemInfo.index][key] = value;

    setBulkForm((prevState) => ({
      ...prevState,
      expenses: updatedItems,
    }));
  };

  const { mutate: resolveAccount } = useResolveBankAccount();
  const handleResolveAccountNumber = (bankCode, accountNumber) => {
    resolveAccount(
      { bank_code: bankCode, account_number: accountNumber },
      {
        onSuccess: (res) => {
          handleUpdateKey({
            key: "account_name",
            value: res?.data?.data?.account_name,
          });
        },
        onError: () => {
          handleUpdateKey({
            key: "account_name",
            value: null,
          });
        },
      },
    );
  };

  const { handleUploadMedia, isLoading } = useUploadImageMutation({
    onSuccess: (data) => {
      handleUpdateKey({ key: "proof_url", value: data?.url });
      handleUpdateKey({ key: "file_name", value: data?.file_name });
    },
  });

  useEffect(() => {
    if (
      bulkForm?.expenses?.[itemInfo?.index]?.bank_code &&
      bulkForm?.expenses?.[itemInfo?.index]?.account_number?.length === 10
    )
      handleResolveAccountNumber(
        bulkForm?.expenses?.[itemInfo?.index]?.bank_code,
        bulkForm?.expenses?.[itemInfo?.index]?.account_number,
      );
  }, [
    bulkForm?.expenses?.[itemInfo?.index]?.account_number,
    bulkForm?.expenses?.[itemInfo?.index]?.bank_code,
  ]);

  return (
    <div className={`${globalStyles.pageColumnGaps}`}>
      <div className={`${globalStyles.pageColumnGaps} flex-md-row p-0`}>
        <div
          className={`${globalStyles.cardWithBackground} white w-100 p-0`}
          style={{ gap: "25px" }}
        >
          <div
            className={`${globalStyles.cardWithBorder} white flex-row w-100 px-3 py-1 justify-content-between align-items-center`}
            style={{ gap: "25px", borderRadius: "20px" }}
          >
            <p className="dark--text small-text-size">
              Requires disbursement of funds into account?
            </p>

            <div className="d-flex" style={{ gap: "10px" }}>
              <primaryComponents.RadioButtonV2
                name={`disbursment${itemInfo}`}
                label="Yes"
                id={`Yes${itemInfo?.id}`}
                checked={bulkForm?.expenses?.[itemInfo?.index]?.is_disbursment}
                onChange={() => {
                  handleUpdateKey({ key: "is_disbursment", value: true });
                }}
              />
              <span
                style={{ height: "30px", borderLeft: "1px solid #ddd" }}
              ></span>

              <primaryComponents.RadioButtonV2
                name={`disburment${itemInfo}`}
                id={`No${itemInfo?.id}`}
                label="No"
                checked={!bulkForm?.expenses?.[itemInfo?.index]?.is_disbursment}
                onChange={() => {
                  handleUpdateKey({ key: "is_disbursment", value: false });
                  handleUpdateKey({ key: "account_number", value: "" });
                  handleUpdateKey({ key: "bank_code", value: "" });
                }}
              />
            </div>
          </div>

          {bulkForm?.expenses?.[itemInfo?.index]?.is_disbursment ? (
            <>
              <primaryComponents.SelectField
                name="bank_code"
                label="Bank"
                isRequired
                value={
                  bankList?.find(
                    (bank) =>
                      `${bank?.bank_code}` ===
                      `${bulkForm?.expenses?.[itemInfo?.index]?.bank_code}`,
                  )?.bank_name || "Select bank"
                }
                options={bankList}
                nameKey="bank_name"
                idKey="bank_code"
                onChange={(value) => {
                  handleUpdateKey({ key: "bank_code", value });
                }}
              />

              <div>
                <primaryComponents.InputField
                  label="Account Number"
                  isRequired
                  placeholder="Enter 10-digit account number"
                  name="account_number"
                  classNames="white"
                  floatError={false}
                  value={bulkForm?.expenses?.[itemInfo?.index]?.account_number}
                  onChange={({ target: { value } }) => {
                    handleUpdateKey({ key: "account_number", value });
                  }}
                />

                {bulkForm?.expenses?.[itemInfo?.index]?.account_name && (
                  <p className="small-text-size purple--text">
                    {bulkForm?.expenses?.[itemInfo?.index]?.account_name}
                  </p>
                )}
              </div>
            </>
          ) : null}

          <primaryComponents.TextArea
            classNames="white"
            placeholder={"Enter description"}
            label={"Description"}
            value={bulkForm?.expenses?.[itemInfo.index]?.description}
            onChange={({ target: { value } }) => {
              handleUpdateKey({ key: "description", value });
            }}
            floatError={false}
          />
        </div>

        <div
          style={{ minWidth: "40%" }}
          className={`w-100 ${globalStyles.cardWithBorder} card-plain px-0`}
        >
          <div className="d-flex justify-content-between px-3">
            <div>
              <h6 className="mb-0">Waybill</h6>
              <p className="gray--text small-text-size">Upload image here</p>
            </div>

            <div>
              <primaryComponents.FileInput
                name="waybillReceipt"
                placeHolder={"Upload File"}
                coverStyle={{ width: "170px" }}
                floatError={false}
                truncateTextSize={15}
                onChange={(document, fileName) => {
                  handleUploadMedia(document, fileName);
                }}
              />
            </div>
          </div>

          {!bulkForm?.expenses?.[itemInfo?.index]?.proof_url ? (
            <>
              <hr />
              <div className="text-center mt-3 px-3">
                <WaybillImage />
                <p>
                  No file uploaded
                  <br />
                  File uploaded will appear here
                </p>
              </div>
            </>
          ) : (
            <div
              className={`${globalStyles.cardWithBorder} flex-row align-items-center justify-content-between white px-3`}
              style={{
                borderRadius: 0,
                borderRight: "none",
                borderLeft: "none",
              }}
            >
              <span className="d-flex align-items-center">
                <WaybillIcon className="mr-2" />
                {bulkForm?.expenses?.[itemInfo?.index]?.file_name}
              </span>

              <span
                className="cursor-pointer d-flex align-items-center"
                onClick={() =>
                  window.open(bulkForm?.expenses?.[itemInfo?.index]?.proof_url)
                }
              >
                <EyeIcon />
                <span className="purple--text small-text-size ml-2">
                  View File
                </span>
              </span>
            </div>
          )}
        </div>
      </div>

      <primaryComponents.Button
        classNames={"btn btn--primary"}
        isDisabled={isLoading}
        onClick={() => {
          const formItem = bulkForm?.expenses?.[itemInfo?.index];
          if (
            formItem?.account_number?.length !== 10 &&
            formItem?.is_disbursment
          )
            return triggerToast("A valid account number is required");

          if (
            (!formItem?.bank_code || formItem === "") &&
            formItem?.is_disbursment
          )
            return triggerToast("Please select a bank");

          closeModal();
        }}
      >
        Done
      </primaryComponents.Button>
    </div>
  );
};
